import { v4 as uuid } from "uuid";
import Ajv from "ajv";
import ShoppingCartItem from "./ShoppingCartItem.schema.json";

const ajv = new Ajv();

import Axios from "axios";

const validateShoppingCartItem = ajv.compile(ShoppingCartItem);

export default () => {
	let url = "https://shopping-cart.api.test.apc.telenor.net/";
	if (import.meta.client) {
		if (
			window.location.host === "staging.telenor.no" ||
			window.location.host === "telenor.no" ||
			window.location.host === "www.telenor.no"
		)
			url = "https://ecommerce.telenor.no/cart";
	} else if (import.meta.server) {
		if (process.env.NODE_ENV === "production") {
			url = "https://ecommerce.telenor.no/cart";
		}
	}

	const axios = Axios.create({
		baseURL: url,
		withCredentials: true,
	});

	axios.interceptors.response.use((res) => res.data);

	const getCart = async () => {
		if (import.meta.client) {
			const fromLocalStorage = JSON.parse(localStorage.getItem("cart"));

			if (fromLocalStorage) return fromLocalStorage;

			/*
            Temporary code to get cart from API until all sessions are using localStorage
             */
			const fromApi = await axios.get("/");
			if (fromApi) {
				localStorage.setItem("cart", JSON.stringify(fromApi));
				return fromApi;
			} else {
				localStorage.setItem("cart", JSON.stringify([])); // Make sure this check is not done again
				return [];
			}
		} else {
			return [];
		}
	};

	const putCart = async (cart) => {
		if (import.meta.client) {
			localStorage.setItem("cart", JSON.stringify(cart));
		}
	};

	const getCartContent = getCart;

	const addItem = async (item) => {
		item = JSON.parse(JSON.stringify(item));
		const valid = validateShoppingCartItem(item);

		if (!valid) throw new Error(validateShoppingCartItem.errors);

		const cart = await getCart();

		if (item.id) {
			const existing = cart.findIndex((i) => i.id === item.id);
			if (existing > -1) cart[existing] = item;
			else cart.push(item);
		} else {
			item.id = uuid();
			cart.push(item);
		}

		putCart(cart);

		return cart;
	};

	const removeItem = async (itemId) => {
		let cart = await getCart();

		const itemIndex = cart.findIndex((item) => item.id === itemId);

		if (itemIndex < 0) throw new Error(`Item not found: ${itemId}`);

		cart.splice(itemIndex, 1);

		putCart(cart);

		return cart;
	};

	const emptyCart = async () => {
		putCart([]);

		axios.delete("/").catch(console.warn);

		return [];
	};

	return {
		getCartContent,
		removeItem,
		addItem,
		emptyCart,
	};
};
